module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/diamonds-ab7e8936b1d474658431b26e9a5ce5db.png";